import { render } from "./StatusBugBacklog.vue?vue&type=template&id=092d08c5&scoped=true"
import script from "./StatusBugBacklog.vue?vue&type=script&lang=js"
export * from "./StatusBugBacklog.vue?vue&type=script&lang=js"

import "./StatusBugBacklog.vue?vue&type=style&index=0&id=092d08c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092d08c5"]])

export default __exports__